import React, { useState } from "react";
import { Button, Tooltip, Modal, Spin, Tag } from "antd";
import { Row, Col } from "reactstrap";
import {
  PlusCircleTwoTone,
  EditOutlined,
  DropboxCircleFilled,
  CloseOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import "../../utils/style.css";
import toast from "react-hot-toast";
import { useQueryClient } from "react-query";
import SelectAccountTypeModal from "../accountType";
import { STATUS_COLORS, STATUS_LABELS } from "../statutMap";
import { deActiveBankAccount } from "../../services/bankApi";
import AddEditBankAccount from "./addEditBankAccount";
import { maskKey } from "../../../../common/format/maskedData";

const AccountsBanks = ({
  accountsBanks = [],
  isLoadBanks,
  isErrorBanks,
  errorBanks,
  onSuccessBank
}) => {
  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const [modalOpen, setModalOpen] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [selectedAcc, setSelectedAcc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 10;
  const queryClient = useQueryClient();
  
  const openAddModal = () => {
    setSelectedAcc(null);
    setModalOpen(true);
  };

  const handleEdit = (acc) => {
    setSelectedAcc(acc);
    setModalEdit(true);
  };

  const merchantId = currentUser?.user?.id
  

  const confirmDelete = (acc) => {
    Modal.confirm({
      title: "Confirmer la suppression",
      content: `Voulez-vous vraiment ${acc.status === "ACTIVE" ? "desactiver" : "activer"} le compte ${acc.maskedName || "-"} (${acc.maskedIban || "-"}) de la banque ${acc.nameBank || "-"} ?`, okText: "Oui",
      okType: "danger",
      cancelText: "Non",
      onOk: async () => {
        try {
          const data = {
            id : acc?.id,
            merchantId : currentUser?.user?.id,
            token : currentUser.token,
          }
          await deActiveBankAccount(data);
          await queryClient.invalidateQueries("accountsBanks");
          toast.success("Compte desactivé avec succès");
        } catch (error) {
          toast.error("Erreur lors de la desactivation du compte");
        }
      },
    });
  };

  const filteredAccountsBanks = accountsBanks
    .filter((acc) => {
      const fullText = `${acc.phone} ${acc.prefix} ${acc.paymentGateway}`.toLowerCase();
      return fullText.includes(searchTerm.toLowerCase());
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  const paginatedaccountsBanks = filteredAccountsBanks.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div>
      <Row>
        <Col lg={6} className="mb-2">
          <Button
            type="primary"
            className="btn-confirm-reversement "
            onClick={openAddModal}
            disabled={currentUser?.adminImpersonation}
          >
            <PlusCircleTwoTone className="me-1" /> 
            {currentUser?.adminImpersonation ? 'Pas autorisé à ajouter un compte' : 'Ajouter un compte de versement'}
          </Button>
        </Col>
        <Col lg={6} className="text-end">
          <input
            type="text"
            className="form-control"
            placeholder="🔎 Rechercher ..."
            value={searchTerm}
            onChange={(e) => {
              setCurrentPage(1);
              setSearchTerm(e.target.value);
            }}
          />
        </Col>
      </Row>

      <div className="add-rever-card">
        <Row className="mb-4">
          {isLoadBanks ? (
            <Col lg={12} className="text-center my-5">
              Chargement des comptes en cours... <Spin />
            </Col>
          ) : isErrorBanks ? (
            <Col lg={12} className="text-center text-danger my-5">
              Une erreur est survenue, contactez le support
            </Col>
          ) : filteredAccountsBanks.length === 0 ? (
            <Col lg={12}>
              <div className="no-account-message text-muted text-center py-5">
                <DropboxCircleFilled style={{ fontSize: 48, color: "#D0D3DC", marginBottom: 12 }} />
                <p className="fw-semibold mb-0">Aucun compte trouvé</p>
                <small className="text-muted">
                  Essayez un autre numéro ou ajoutez un compte.
                </small>
              </div>
            </Col>
          ) : (
            <>
              <Row className="account-table-header mb-2">
                <Col lg={2}><strong>Titulaire</strong></Col>
                <Col lg={2}><strong>Banque</strong></Col>
                <Col lg={3}><strong>IBAN</strong></Col>
                <Col lg={2}><strong>BIC</strong></Col>
                <Col lg={1}><strong>Statut</strong></Col>
                <Col lg={2} className="text-end"><strong>Actions</strong></Col>
              </Row>

              {paginatedaccountsBanks.map((acc, index) => (
                <Row key={index} className="account-table-row align-items-center mb-2">

                  <Col lg={2}>
                    {acc.maskedName || "-"}
                  </Col>

                  <Col lg={2}>
                    {acc.nameBank || "-"}
                  </Col>

                  <Col lg={3}>
                    {maskKey(acc.maskedIban) || "-"}
                  </Col>

                  <Col lg={2}>
                    {acc.maskedBicCode || "-"}
                  </Col>

                  <Col lg={1}>
                    <Tag color={STATUS_COLORS[acc.status]}>
                      {STATUS_LABELS[acc.status]}
                    </Tag>
                  </Col>

                  <Col lg={2} className="text-end">
                    <div className="d-flex justify-content-end gap-2" style={{ width: '100%' }}>
                      <Tooltip title="Modifier">
                        <div
                          className="action-icon edit-icon"
                          onClick={() => handleEdit(acc)}
                        >
                          <EditOutlined />
                        </div>
                      </Tooltip>

                      <Tooltip title={acc.status === "ACTIVE" ? "Désactiver le compte" : "Activer le compte"}>
                        <div
                          className={acc.status === "ACTIVE" ? "action-icon delete-icon" : "action-icon act-icon"}
                          onClick={() => confirmDelete(acc)}
                        >
                          {acc.status === "ACTIVE" ? <CloseOutlined /> : <CheckOutlined />}
                        </div>
                      </Tooltip>
                    </div>
                  </Col>

                </Row>
              ))}
            </>
          )}

          {filteredAccountsBanks.length > itemsPerPage && !isLoadBanks && !isErrorBanks && (
            <div className="d-flex justify-content-end mt-3">
              <Button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
                className="me-2"
              >
                Précédent
              </Button>
              <Button
                disabled={currentPage * itemsPerPage >= filteredAccountsBanks.length}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Suivant
              </Button>
            </div>
          )}
        </Row>

        <SelectAccountTypeModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          isLoading={loading}
          selectedPaymentAccount={selectedAcc}
        />

        <Modal
          open={modalEdit}
          onCancel={() => setModalEdit(false)}
          footer={null}
          destroyOnClose
          width={700}
        >
          <AddEditBankAccount
            selectedPaymentAccount={selectedAcc}
            isEdit={true}
            onSuccessBank={onSuccessBank}
            onClose={() => setModalEdit(false)}
          />
        </Modal>
      </div>
    </div>
  );
};

export default AccountsBanks;
